
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download-from-instagram",
      function () {
        return require("private-next-pages/download-from-instagram/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/download-from-instagram"])
      });
    }
  